const mutations = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val;
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },
  TOGGLE_SHOW_LEGACY_MENUS(state, val) {
    state.showLegacyMenus = val;
    try {
      localStorage.setItem('showLegacyMenus', val ? 'true' : 'false');
    } catch (e) {
      // ignore storage errors (private mode, etc.)
    }
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index === payload.index);

    // update the main list
    state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList.data[index]);
    } else {
      // find item index from starred pages
      const starredPagesIndex = state.starredPages.findIndex((item) => item.index === payload.index);

      // remove item using index
      state.starredPages.splice(starredPagesIndex, 1);
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = [...list, ...starredPagesMore];
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false;
    const lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = [...list, ...starredPagesLimited];

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true;
      return i;
    });

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val;
  }

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // UPDATE_USER_INFO(state, newUserInfo) {
  //   state.AppActiveUser = newUserInfo;
  //   state.AppActiveUser['display_name'] = newUserInfo['first_name'] || null;
  // },
  // UPDATE_USER_ROLE(state, userRoles) {
  //   Vue.set(
  //     state.AppActiveUser,
  //     'roles',
  //     userRoles.filter((r) => r && r !== null)
  //   );
  // },
  // UPDATE_USER_NAV_MENU(state, newUserNavMenu) {
  //   state.AppActiveUserNavMenu = newUserNavMenu;
  // },
  // UPDATE_USER_RULES(state, rules) {
  //   state.rules = rules;
  // },
  // UPDATE_USER_PROMISE(state, promise) {
  //   state.getUserPromise = promise;
  // },
  // UPDATE_USER_IS_LOADED(state, value) {
  //   state.userLoaded = value;
  // }
};

export default mutations;
